import { render, staticRenderFns } from "./MagzNav.vue?vue&type=template&id=7d2cdd84&scoped=true&"
import script from "./MagzNav.vue?vue&type=script&lang=js&"
export * from "./MagzNav.vue?vue&type=script&lang=js&"
import style0 from "./MagzNav.vue?vue&type=style&index=0&id=7d2cdd84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2cdd84",
  null
  
)

export default component.exports